import createGlGroup from "./useGlGroupCreate";
import { useGlGroupFetchAll as fetchAll } from "./useGlGroupFetchAll";
import updateGlGroup from "./useGlGroupEdit";
import deleteGlGroup from "./useGlGroupDelete";

export const useGlCodeGroupCreate = createGlGroup;
export const useGlGroupFetchAll = fetchAll;
export const useGlGroupEdit = updateGlGroup;
export const useGlGroupDelete = deleteGlGroup;
